<template>
  <div v-if="totalPages > 1" class="container-fluid">
    <div class="row">
      <!-- <div class="col-sm-12 col-md-5"></div> -->
      <div class="offset-md-5 col-sm-12 col-md-7">
        <div
          class="dataTables_paginate paging_simple_numbers"
          id="bs4-table_paginate"
        >
          <ul class="pagination">
            <li
              class="paginate_button page-item previous"
              :class="{ disabled: value == 1 }"
              id="bs4-table_previous"
            >
              <a
                href="javascript:void(0)"
                aria-controls="bs4-table"
                data-dt-idx="0"
                tabindex="0"
                class="page-link"
                @click="previousPage"
                ><span class="material-icons-outlined">
                  arrow_back_ios
                </span></a
              >
            </li>
            <li
              v-for="(page, i) in pages"
              :key="i"
              :class="{ active: value == page }"
              class="paginate_button page-item"
            >
              <div v-if="page == '...'" class="page-link">
                {{ page }}
              </div>
              <a
                v-else
                href="javascript:void(0)"
                aria-controls="bs4-table"
                :data-dt-idx="page"
                tabindex="0"
                class="page-link"
                @click="changePage(page)"
                >{{ page }}</a
              >
            </li>
            <li
              class="paginate_button page-item next"
              id="bs4-table_next"
              :class="{ disabled: value == totalPages }"
            >
              <a
                href="javascript:void(0)"
                aria-controls="bs4-table"
                data-dt-idx="7"
                tabindex="0"
                class="page-link"
                @click="nextPage"
                ><span class="material-icons-outlined">
                  arrow_forward_ios
                </span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['value', 'totalPages'],
  data() {
    return {
      currentPage: this.value,
    };
  },
  computed: {
    startPage() {
      if (this.currentPage >= 4 && this.currentPage < this.totalPages) {
        return this.currentPage - 1;
      }
      return Math.max(1, this.currentPage - 2);
    },
    endPage() {
      if (this.currentPage < this.totalPages - 2 && this.currentPage > 1) {
        return this.currentPage + 1;
      }
      return Math.min(this.totalPages, this.currentPage + 2);
    },
    pages() {
      const range = [];

      if (this.currentPage >= 4) {
        range.push(1);
        if (this.totalPages > 4) range.push('...');
      }

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push(i);
      }

      if (this.currentPage < this.totalPages - 2) {
        if (this.totalPages > 4) range.push('...');
        range.push(this.totalPages);
      }

      return range;
    },
  },
  methods: {
    previousPage() {
      this.changePage((this.currentPage -= 1));
    },
    nextPage() {
      this.changePage((this.currentPage += 1));
    },
    changePage(page) {
      this.$emit('input', page);
      this.$forceUpdate();
      this.$emit('change', page);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin: 2px 0;
  white-space: nowrap;
  justify-content: flex-end;
}
</style>
